
<template>
  <router-view />
</template>

<style lang="scss">

.el-dialog__headerbtn .el-dialog__close,
.el-drawer__close-btn .el-icon-close {
  font-weight: bold;
  font-size: 16px !important;
  color: #003369 !important;
}

</style>
